import React, { Component } from "react";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import axios from "axios";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Form from "react-bootstrap/Form";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  NewInputText,
  PasswordReusableInput,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import { FormHelperText } from "@material-ui/core";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { superadmin_create_vendor } from "../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { SignupValidation } from "../../../../store/validation/allValidationFile/authenticationValidation/SignupValidation";
import isEmpty from "../../../../store/validation/is-Empty";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export class SuperAdminAddVendorSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country_code: "",
      country: "",
      number: "",
      email: "",
      password: "",
      confirm_password: "",
      referral_code: "",
      role: "vendor",
      view: false,
      view2: false,
      passwordIcon: true,
      slashEyeIcon: false,
      errors: {},
      error: null,
      isLoading: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.props.clear_all_errors();
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          country: result.data.country_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, errors: {} }, () => {});
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "email" &&
      !validEmailRegex.test(e.target.value)
    ) {
      errors[e.target.name] = `A valid email is required!`;
    } else if (e.target.name === "password" && e.target.value.length < 6) {
      errors[e.target.name] = `Please enter a valid password`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "email":
        errors.email = validEmailRegex.test(value)
          ? ""
          : "Enter Valid Email Address";
        break;
      case "password":
        errors.password =
          value.length < 6 ? "Password must contain atleast 6 characters" : "";
        break;
      case "confirm_password":
        errors.confirm_password =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  handleClickShowPassword = (e) => {
    this.setState({
      view: !this.state.view,
    });
  };

  handleClickShowPassword2 = (e) => {
    this.setState({
      view2: !this.state.view2,
    });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("vendorId", null);
    const token = this.props.auth.user.accessToken;
    const { errors, isValid } = SignupValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const formData = {
        country_code: this.state.country_code,
        country: this.state.country,
        mobile_number: this.state.number,
        email: this.state.email,
        password: this.state.password,
        confirm_password: this.state.confirm_password,
        referral_code: this.state.referral_code,
        role: this.state.role,
      };
      this.props.superadmin_create_vendor(formData, token, this.props.history);
    }
  };

  renderFunSignup = () => {
    const { number, email, password, confirm_password, errors } = this.state;
    return (
      <React.Fragment>
        <div className="col-5">
          <Form.Row className="input-component-insideRow mb-4">
            <div className="col-4 col-xl-3 pr-0">
              <Form.Group controlId={"country_code"}>
                <div className="input-phone-country-code-reusable w-100">
                  <select
                    name="country_code"
                    className="w-100"
                    value={this.state.country_code}
                    onChange={this.onChange}
                  >
                    <option value={this.state.country_code}>
                      {this.state.country_code}
                    </option>
                    {getCountries().map((country) => (
                      <option
                        key={country}
                        value={"+" + getCountryCallingCode(country)}
                      >
                        {en[country]} (+
                        {getCountryCallingCode(country)})
                      </option>
                    ))}
                  </select>
                </div>
              </Form.Group>
            </div>
            <div className="col-8 col-xl-9">
              <NewInputText
                extraClass="mb-0"
                name="number"
                inputType="number"
                onFocusOut={this.onFocusOut}
                onChange={this.onChange}
                onKeyDown={InputNumberFunc}
                value={this.state.number}
                maxLength="10"
                errorText={
                  this.state.number.length > 0 && this.state.number.length <= 9
                    ? "Enter valid Mobile Number"
                    : null || errors.number === "number is required"
                    ? "mobile number is required"
                    : null
                }
                errorTrue={
                  (this.state.number.length > 0 &&
                    this.state.number.length <= 9) ||
                  errors.number === "number is required"
                    ? true
                    : false
                }
                labelText="Phone Number"
                controlClass={
                  (this.state.number.length > 0 &&
                    this.state.number.length <= 9) ||
                  errors.number === "number is required"
                    ? "outlined-error-helper-text"
                    : "outlined-helperText"
                }
              />
            </div>
          </Form.Row>
        </div>
        <div className="col-5 mb-4">
          <NewInputText
            extraClass="mb-0"
            name="email"
            inputType="email"
            onFocusOut={this.onFocusOut}
            onChange={this.handleChange}
            value={this.state.email}
            errorText={
              !validEmailRegex.test(email) && !isEmpty(email)
                ? "Please enter a valid email"
                : null || errors.email === "email is required"
                ? "email is required"
                : ""
            }
            errorTrue={
              (!validEmailRegex.test(email) && !isEmpty(email)) ||
              errors.email === "email is required"
                ? true
                : false
            }
            labelText="E-mail Address"
            controlClass={
              (!validEmailRegex.test(email) && !isEmpty(email)) ||
              errors.email === "email is required"
                ? "outlined-error-helper-text"
                : "outlined-helperText"
            }
          />
        </div>
        <div className="col-5 mb-4">
          <PasswordReusableInput
            extraClass="w-100"
            labelText="Enter Password"
            inputTypeState={this.state.view}
            value={this.state.password}
            name="password"
            onFocusOut={this.onFocusOut}
            handleChange={this.handleChange}
            handleClickShowPassword={this.handleClickShowPassword}
            handleMouseDownPassword={this.handleMouseDownPassword}
            errorText={
              errors.password === "password is required"
                ? errors.password
                : null
            }
            errorTrue={
              errors.password === "password is required" ? true : false
            }
            wLabel={120}
          />
        </div>
        <div className="col-5 mb-4">
          <PasswordReusableInput
            extraClass="w-100"
            labelText="Confirm Password"
            inputTypeState={this.state.view2}
            value={this.state.confirm_password}
            name="confirm_password"
            onFocusOut={this.onFocusOut}
            handleChange={this.handleChange}
            handleClickShowPassword={this.handleClickShowPassword2}
            handleMouseDownPassword={this.handleMouseDownPassword}
            errorText={
              this.state.confirm_password.length === 0
                ? errors.confirm_password
                : "Password and Confirm Password do not match" &&
                  this.state.password !== this.state.confirm_password
                ? "Password and Confirm Password do not match"
                : ""
            }
            errorTrue={
              this.state.confirm_password.length === 0
                ? errors.confirm_password
                : "Password and Confirm Password do not match" &&
                  this.state.password !== this.state.confirm_password
            }
            wLabel={140}
          />
        </div>
        <div className="col-5">
          <NewInputText
            extraClass="mb-2"
            name="referral_code"
            inputType="text"
            onFocusOut={this.onFocusOut}
            onChange={this.onChange}
            onKeyDown={InputNumberFunc}
            value={this.state.referral_code}
            maxLength="10"
            labelText="Referral Code"
            errorText={errors.code === 401 ? errors.message : ""}
            errorTrue={errors.code === 401 ? true : false}
            controlClass={
              errors.code === 401
                ? "outlined-error-helper-text"
                : "outlined-helperText"
            }
          />
          {errors.code === 409 ? (
            <div className="mb-4">
              <FormHelperText
                id="outlined-error-helper-text"
                style={{ color: "#f44336" }}
              >
                Phone number / Email already exists
              </FormHelperText>
            </div>
          ) : null}
        </div>

        <div className="col-12 d-flex mt-3">
          <div className="mr-3">
            <PopupActionButton
              buttonText="Cancel"
              buttonType="button"
              buttonClass="noButton"
              onClick={(e) => this.props.history.push("/superadminallvendors")}
            />
          </div>
          <PopupActionButton
            buttonText="Create Merchant"
            buttonType="submit"
            buttonClass={
              number.length <= 9 ||
              password.length < 6 ||
              confirm_password.length < 6 ||
              password !== confirm_password ||
              email === "" ||
              errors.email === "Enter Valid Email Address"
                ? "noButton"
                : "yesButton"
            }
            disabled={
              number.length <= 9 ||
              password.length < 6 ||
              confirm_password.length < 6 ||
              password !== confirm_password ||
              email === "" ||
              errors.email === "Enter Valid Email Address"
                ? true
                : false
            }
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader /> 
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="Add Vendor" />
              <div className="super-admin-inside-right-side-panel">
                <div className="super_admin_add_vendor">
                  <h5 className="main_header_text">Add Vendor</h5>
                  <h4 className="font_20_m">Step :1</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">
                    Basic Information
                  </h4>
                  <hr className="hr_line" />

                  <Form
                    noValidate
                    onSubmit={this.handleSubmit}
                    className="mt-5 col-8"
                  >
                    <div className="row">{this.renderFunSignup()}</div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminAddVendorSignup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  superadmin_create_vendor,
  clear_all_errors,
})(withRouter(SuperAdminAddVendorSignup));
